declare global {
  interface Window {
    CookieScript: {
      [x: string]: any;
    };
  }
}

export const CookieLinkCLickHandler = () => {
  const cookieLink = document.querySelector<HTMLElement>(".cookie-link");
  if (cookieLink) {
    cookieLink.addEventListener("click", (e) => {
      e.preventDefault();
      window.CookieScript.instance.show();
    });
  }
};
